
import {useContext, useEffect, useRef, useState} from "react";
import {appContext} from "./state";

import Clone from "./utils/clone";
import {getRequestByKey, getRequestIndexByKey, getRequestKey} from "./utils/requests";
import {checkAuth, doConfirmEmailToken} from "./utils/auth";
import {App, Modal} from "antd";
import SignInUp from "./components/SignInUp";
import Pricing from "./components/Pricing";
import {CloseOutlined} from "@ant-design/icons";
import {clearUrl} from "./utils/general";
import LiveMode from "./components/LiveMode";
const WS_ENDPOINT = process.env.REACT_APP_WS_ENDPOINT

function AppWrapper(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState); // inside the event listeners like for sockets/click listeners it will keep the appState defined at the moment the listener was created. This can be outdated
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [liveModeModeRequest, setLiveModeRequest] = useState(null);
    const { message, modal, notification } = App.useApp();

    let webSocket = useRef(null)
    let reconnectInterval
    useEffect(() => {
        doAuth()
        checkEmailConfirmToken().then({})
    }, []);

    const doAuth = () => {
        checkAuth(appStateRef.current.targetAPI).then( (authRes) => {
            console.log('AUTH_RES:',!!authRes,authRes)
            if (authRes) {
                localStorage.setItem('token',authRes.token)
                let newAppState = Clone(appStateRef.current)
                newAppState.user.isAnonymous = authRes.user.isAnonymous
                newAppState.user.uuid = authRes.user.uuid
                newAppState.user.email = authRes.user.email
                newAppState.user.authProvider = authRes.user.authProvider
                console.log('MOCK_API:',authRes.subdomains ? authRes.subdomains[0]?.name : false)
                newAppState.subdomains = authRes.subdomains
                let first = authRes.subdomains[0]
                if (first) {
                    newAppState.mockAPI = first.name
                    newAppState.requestsCount = first.requestsCount || 0
                    newAppState.requestsLimit = first.requestsLimit || 0
                }
                setAppState(newAppState)
                initWebsocket()
                if (newAppState.requestsCount >= newAppState.requestsLimit) {
                    setIsLoginModalOpen(true)
                }
            }
        })
    }

    async function checkEmailConfirmToken () {
        let confirmEmailToken = new URLSearchParams(document.location.search).get('confirm-email-token')
        //console.log('confirmEmailToken',confirmEmailToken)
        if (confirmEmailToken) {
           let res = await doConfirmEmailToken(confirmEmailToken)
            console.log('CONFIRM_EMAIL_RES:',res)
            if (!res.error) {
                message.open({type: 'success', content: 'Thank for confirming you Email!'});
                clearUrl()
            }
        }
    }

    useEffect(() => {
        appStateRef.current = appState
    },[appState]);

    const initWebsocket = () => {
        webSocket.current = new WebSocket(WS_ENDPOINT+'/?uuid='+appState.user.uuid)
        window.app.socket = webSocket.current
        webSocket.current.addEventListener('open',onSocketOpen);
        webSocket.current.addEventListener('close',onSocketClose);
        webSocket.current.addEventListener('message',onSocketMessage);
    }

    const onSocketClose = () => {
        console.log('ON_SOCKET_CLOSED')
        updateWSConnectionStatus(false)
        if (reconnectInterval) {
            clearInterval(reconnectInterval)
        }
        reconnectInterval = setInterval( () => {
            console.log('TRY_RECONNECT')
            doAuth()
        },10_000)
    }
    const onSocketOpen = () => {
        if (reconnectInterval) {
            clearInterval(reconnectInterval)
        }
       updateWSConnectionStatus(true)
        console.log('WS_CONNECTED')
    };

    let updateWSConnectionStatus = (status) => {
        //let newAppState = {...appStateRef.current}
        let newAppState = Clone(appStateRef.current)
        newAppState.isConnectedToWs = status
        setAppState(newAppState)
    }

    const onSocketMessage = (event) => {
        //console.log("MSG_FROM_SERVER:", event);
        try {
            let json = JSON.parse(event.data)
            let newAppState = appStateRef.current
            newAppState.trigger = ''
            console.log('ON_SOCKET_MSG',json.action,json)

            if (json.action === 'REQUEST') {
                let existingRequest = getRequestByKey(newAppState.requests,getRequestKey(json.request))
                console.log('EXISTING:',existingRequest,"|",json.request.id, json)
                if (existingRequest) {
                    json.request.key = json.request.id
                    existingRequest.request.subRequests.unshift(Clone(json.request))
                    newAppState.requestsCount = json.requestsCount
                    newAppState.requestsLimit = json.requestsLimit
                    setAppState(newAppState)
                } else {
                    if (!json.request.isFromCache ||  newAppState.requests.length === 0) {
                        json.request.key = json.request.id
                        json.request.subRequests = [Clone(json.request)]
                        newAppState.activeRequestID = json.request.id
                        newAppState.requests.unshift({
                            key:json.request.id,
                            request:json.request
                        })
                        newAppState.requestsCount = json.requestsCount
                        newAppState.requestsLimit = json.requestsLimit
                        console.log('SET_ACTIVE_REQUEST_ID_TO::', json.request.id)
                        setAppState(newAppState)
                    }
                }
                let reachedLimit =  newAppState.requestsCount >= newAppState.requestsLimit

                if (!reachedLimit && newAppState.isLiveModeActive) {
                    setLiveModeRequest({request:json.request})
                }
                if (reachedLimit) {
                    setIsLoginModalOpen(true)
                }
            }
            if (json.action === 'RESPONSE') {
                //console.log('ADD_RESPONSE',json.response.id)
                json.response.key = json.response.id
                let newAppState = Clone(appStateRef.current)
                let requestIndex = getRequestIndexByKey(newAppState.requests,getRequestKey(json.request))
                //console.log('FOUND_CORRESPONDING_REQ:',json.response.id,requestIndex)
                if (requestIndex !==-1) {
                    newAppState.requests[requestIndex].response = json.response
                    animateRow(newAppState.requests[requestIndex])

                    newAppState.editorContentType = json.response?.headers['content-type'] || 'application/json'
                    newAppState.editorBody = json.response.body
                    newAppState.editorBodyID = json.response.id

                    newAppState.editorHeaders = json.response.headers

                    setAppState(newAppState)
                } else {
                    console.warn('Request not matched',json)
                }
            }

            if (json.action === 'REGISTERED') {

            }
        } catch (e) {
            console.error(e)
        }
    }


    function animateRow (existingRequest) {
        let row = document.querySelector(`.requests-list tr[data-row-key="${existingRequest.key}"]`)
        if (row) {
            let listener = (e) => {
                row.removeEventListener('animationend',listener)
                row.classList.remove('on-new-request')
            }
            row.addEventListener('animationend', listener)
            row.classList.add('on-new-request')
        }
    }

    function onPricingModalClose () {
        let newAppState = {...appState}
        newAppState.isPricingModalOpen = false
        setAppState(newAppState)
    }

    function onIgnoreLiveModeRequest () {
        setLiveModeRequest(null)
    }

    async function onRespondToLiveModeRequest (response) {
        setLiveModeRequest(null)
        try {
            const url = process.env.REACT_APP_SERVER_API_HOST+'/user/respond-to-live-mode-request';
            let headers = new Headers();
            headers.append('content-type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
                body:JSON.stringify({response:{headers:response.headers,body:response.body,status:response.status}})
            }
            const requestResponse = await fetch(url, requestOptions);
            if (!requestResponse.ok) {
                console.error(new Error(`Response status: ${requestResponse.status}`))
            }
            //const json = await requestResponse.json();
        } catch (e) {
            console.log(e)
        }
    }

    return <>
            {props.children}

        {isLoginModalOpen ?
            <div className="view auth modal">
                <div className="wrapper">
                    <SignInUp></SignInUp>
                </div>
            </div>
        : false }

        {liveModeModeRequest ?
            <div className="view live-mode modal">
                <div className="wrapper">
                  <LiveMode onRespondToLiveModeRequest={onRespondToLiveModeRequest} onIgnoreLiveModeRequest={onIgnoreLiveModeRequest} request={liveModeModeRequest}></LiveMode>
                </div>
            </div>
            : false }

        {appState.isPricingModalOpen ?
            <div className="modal-cont">
                <div className="modal-window">
                    <div onClick={onPricingModalClose} className="close">
                        <CloseOutlined></CloseOutlined>
                    </div>
                <Pricing plans={[
                    {id:1,title:'Mocky Free',features:[{title:'Feature 1'}]},
                    {id:2,title:'Mocky Pro',features:[{title:'Feature 1'},{title:'Feature 2'},{title:'Feature 3'},{title:'Feature 4'}]},
                    {id:3,title:'Mocky Enterprise',features:[{title:'Feature 1'},{title:'Feature 2'},{title:'Feature 3'},{title:'Feature 4'}]},
                ]}></Pricing>
                </div>
            </div>
            : false }

            </>
        }



        export default AppWrapper;
